'use client';

import { useCallback, useState } from 'react';
import { toast } from 'sonner';
import type { GlobalFilterItem } from '../types';
import { computeToggledFilteredItems } from '../utils';

/**
 * Selection state + toggle handling (incl. the segment-exclusivity toast).
 * Shared between the legacy GlobalFilterModal and the global-search-v2
 * filter page.
 */
export function useFilteredItems(initial: GlobalFilterItem[]) {
  const [filteredItems, setFilteredItems] =
    useState<GlobalFilterItem[]>(initial);

  const toggleFilteredItem = useCallback((item: GlobalFilterItem) => {
    let shouldShowToast = false;

    setFilteredItems((prev) => {
      const { items, shouldToast } = computeToggledFilteredItems(prev, item);
      shouldShowToast = shouldToast;
      return items;
    });

    if (shouldShowToast) {
      toast.info('Filtering rensad', {
        description:
          'Det är inte möjligt att kombinera "Segment" med andra filter',
      });
    }
  }, []);

  return { filteredItems, setFilteredItems, toggleFilteredItem };
}
